import {
  getLanguageEnum,
  getQueryParamValue,
  getServerDateFormat,
  getWebinarDateTimeFromSelectedSlot
} from '@nw/shared/utils';

interface CommonRequestPropertiesTypes {
  values: Record<string, any>;
}

export const generateCommonRequestProperties = ({
  values
}: CommonRequestPropertiesTypes): any => {
  const {
    preferredLanguage,
    preferredLanguages,
    selectADateToBookASlot,
    languageEnum
  } = values;

  const languageValue = preferredLanguage || preferredLanguages;
  let preferredLanguageEnum = languageValue && getLanguageEnum(languageValue);

  if (languageEnum) {
    preferredLanguageEnum = languageEnum;
  }

  let segmentWebinarDateTime;

  if (selectADateToBookASlot) {
    segmentWebinarDateTime = getWebinarDateTimeFromSelectedSlot(
      selectADateToBookASlot,
      values['timeSlots'] as string
    );
  }

  return {
    selected_slot_language: preferredLanguageEnum,
    segmentDateTime: segmentWebinarDateTime,
    selected_webinar_slot_datetime:
      segmentWebinarDateTime &&
      getServerDateFormat(new Date(segmentWebinarDateTime)),
    ...values,
    tabsDetails: undefined
  };
};

export const generateRequestObjectBasedOnProductCode = ({
  productCode,
  values,
  requestObject
}: {
  productCode: string;
  values: Record<string, any>;
  requestObject: Record<string, any>;
}) => {
  if (productCode === 'NIAT_OFFICE_VISIT') {
    return {
      ...requestObject,
      phoneNumber: values['MOBILE_NUMBER'] ?? '',
      studentPhoneNumber: values['MOBILE_NUMBER'] ?? '',
      gender: values['GENDER'] ?? '',
      parentName: values['PARENT_NAME'] ?? '',
      parentPhoneNumber: values['PARENT_MOBILE_NUMBER'] ?? '',
      parentOccupation: values['PARENT_OCCUPATION'] ?? '',
      otherOccupation: '',
      platform: 'application_portal'
    };
  } else if (productCode === 'ADMISSION_FEE') {
    return {
      ...requestObject,
      platform: 'application_portal',
      current_district: values['NATIVE_DISTRICT'] ?? '',
      dateOfBirth: '',
      parentOrGuardianFullName: values['PARENT_NAME'] ?? '',
      parentOrGuardianPhoneNumber: values['PARENT_MOBILE_NUMBER'] ?? '',
      preferredLanguage: values['PREFERRED_LANGUAGE'][0] ?? '',
      preferredUniversity: values['preferredUniversity'],
      accomodationMode: 'Day Scholar',
      cge: getQueryParamValue('cge')
    };
  } else if (productCode === 'NIAT_PREPARATORY_SESSION_REGISTRATION') {
    return {
      ...requestObject,
      platform: 'application_portal',
      current_district: values['NATIVE_DISTRICT'] ?? '',
      phoneNumber: values['MOBILE_NUMBER'] ?? '',
      language: values['PREFERRED_LANGUAGE'][0] ?? '',
      parentOrGuardianFullName: values['PARENT_NAME'] ?? '',
      parentOrGuardianPhoneNumber: values['PARENT_MOBILE_NUMBER'] ?? ''
    };
  } else if (productCode === 'NIAT_COUNSELLING_REGISTRATION') {
    return {
      ...requestObject,
      platform: 'application_portal',
      current_district: values['NATIVE_DISTRICT'] ?? '',
      phoneNumber: values['MOBILE_NUMBER'] ?? '',
      language: values['PREFERRED_LANGUAGE'][0] ?? ''
    };
  } else if (productCode === 'NIAT_CLOSURE_SLOT_BOOKING') {
    return {
      ...requestObject,
      platform: 'application_portal',
      current_district: values['NATIVE_DISTRICT'] ?? '',
      phoneNumber: values['MOBILE_NUMBER'] ?? '',
      language: values['PREFERRED_LANGUAGE'][0] ?? ''
    };
  } else return requestObject;
};
